import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Form, Row, Button, Col } from 'antd';
import { useLifeEnquirySubmission } from 'all-in-one-shared-api';
import { useKeycloakReady } from 'hooks/useKeycloakReady';
import { Attachments } from 'types';
import { TIME_TYPE } from '../utils/timeTypes';
// import { POLICY_TYPE } from '../utils/policyTypes';
import { LIFE_ENQUIRY_TYPE } from '../utils/enquiryTypes';
import { revalidateAntdFormLanguageChanged } from '../../../i18n';
import GreetingSection from '../../../components/navbar/GreetingSection';
import styled from 'styled-components';
import { EnquirySuccessPage } from './EnquirySuccessPage';
import './Enquirystyle.less';
import { AgreementCard, DocumentsCard, EnquiryInfoCard } from '../components';
import { useSearchParams } from 'react-router-dom';

//定义类型
type EnquiryFormInput = {
  enquiryType: LIFE_ENQUIRY_TYPE;
  name: string;
  email: string;
  phone: string;
  feedback: string;
  PolicyNo?: Array<string>;
  attachments: Attachments;
  countryCode: string;
  contactTime: TIME_TYPE;
};
// interface FormProps {
//   contactTime: TIME_TYPE;
//   yourPolicy: POLICY_TYPE;
//   enquiryType: LIFE_ENQUIRY_TYPE;
//   email: string;
//   phone: string;
//   enquiryMessage: string;
//   terms: boolean;
//   countryCode: string;
//   memberName: string;
// }

//内容部分布局
const EnquiryPageContainer = styled.div`
  margin: 0;
`;

//页面
function MakeAnEnquiryPage() {
  //定义变量
  const { t, i18n } = useTranslation();
  const [form] = Form.useForm<EnquiryFormInput>();
  const [documentInvalid, setDocumentInvalid] = useState(false);
  const [isAgreed, setIsAgreed] = useState(false);
  const [enquiryReference, setEnquiryReference] = useState('');
  const [attachments, setAttachments] = useState<Attachments>();
  const [isDone, setIsDone] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { token } = useKeycloakReady();
  const [a, seta] = useState('');
  const [searchParams] = useSearchParams();
  // const methods = useForm();
  const [snackbarMessage, setSnackbarMessage] = useState('');
  useEffect(() => {
    revalidateAntdFormLanguageChanged(form);
  }, [i18n.language, form]);
  useEffect(() => {
    // 直接操作 searchParams 避免中间对象
    if (searchParams.toString()) {
      // 有参数时 toString() 非空
      const paramsObj = Object.fromEntries(searchParams.entries());
      form.setFieldsValue({
        feedback: paramsObj.enquiryMessage,
        enquiryType: paramsObj.enquiryType ? t('life.enquiry.lifetype.POLICY_CHANGE') : undefined,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams]);
  //定义方法
  //提交
  const {
    shouldFetch: shouldPostEnquirySubmission,
    data: enquirySubmissionData,
    isLoading: enquirySubmissionIsLoading,
    error,
  } = useLifeEnquirySubmission(
    {
      key: 'useLifeEnquirySubmission',
      params: { form: form.getFieldsValue() },
    },
    token || '',
    {
      enquiryType: form.getFieldValue('enquiryType'),
      email: form.getFieldValue('mail'),
      mobile: form.getFieldValue('phone') ? `${form.getFieldValue('countryCode')} ${form.getFieldValue('phone')}` : '', //pingjie countryCode
      message: form.getFieldValue('feedback'),
      memberName: form.getFieldValue('name'),
      contactTime: form.getFieldValue('phone') ? form.getFieldValue('contactTime') : '',
      policyNumber: a,
      files: attachments?.fileList?.map((a) => a.originFileObj),
      uploadFlag: false,
    },
  );
  useEffect(() => {
    if (enquirySubmissionData) {
      setEnquiryReference(enquirySubmissionData.message);
    }
    if (error) {
      setSnackbarMessage(error.message);
    }
  }, [enquirySubmissionData, error]);
  // const handleCloseSnackbar = () => {
  //   setSnackbarMessage('');
  // };
  useEffect(() => {
    if (!snackbarMessage) return;
    shouldPostEnquirySubmission(false);
    setIsLoading(false);
  }, [snackbarMessage, shouldPostEnquirySubmission, isLoading]);
  useEffect(() => {
    if (!enquiryReference) return;
    shouldPostEnquirySubmission(false);
    setIsDone(true);
    setIsLoading(false);
  }, [enquiryReference, setIsDone, setIsLoading, shouldPostEnquirySubmission]);
  const onSubmit = (values: EnquiryFormInput) => {
    setSnackbarMessage('');
    setEnquiryReference('');
    if (form.getFieldValue('PolicyNo')) {
      const b = form
        .getFieldValue('PolicyNo')
        .map((item: string) => item.toString())
        .join(',');
      seta(b);
    }
    // console.log('-=====', values);
    console.log('++++++++++', values.attachments);
    console.log('-=====', attachments);
    setAttachments(values.attachments);
    setTimeout(() => shouldPostEnquirySubmission(true), 500);
    setIsLoading(true);
  };
  // useEffect(() => {
  //   if (attachments && attachments.fileList.length > 0) {
  //     shouldPostEnquirySubmission(true);
  //     setIsLoading(true);
  //   }
  // }, [attachments, shouldPostEnquirySubmission]);
  if (isDone) {
    return <EnquirySuccessPage enquiryReference={enquiryReference} />;
  }
  return (
    <EnquiryPageContainer className="Enquiry">
      <GreetingSection pageName={t('life.support.enquiry')} showicon={false} />
      <Row justify="center" gutter={[16, { xs: 8, sm: 8, lg: 24 }]} className="EnquiryContent">
        <Row
          justify="center"
          gutter={[16, { xs: 8, sm: 8, lg: 24 }]}
          style={{ background: '#fff' }}
          className="centerlist"
        >
          <Col xs={{ span: 24 }} sm={{ span: 20 }} lg={{ span: 24 }}>
            <Form
              // initialValues={initialValues}
              layout={'vertical'}
              requiredMark={false}
              onFinish={onSubmit}
              validateTrigger={'onSubmit'}
              form={form}
              className="form"
              scrollToFirstError={{ behavior: 'smooth', block: 'center' }}
              style={{ margin: '0 auto' }}
            >
              <EnquiryInfoCard />
              <DocumentsCard setInvalid={setDocumentInvalid} />
              <AgreementCard setIsAgreed={setIsAgreed} />
              <Col xs={24} md={24}>
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                  <Button
                    loading={enquirySubmissionIsLoading || isLoading}
                    disabled={documentInvalid || !isAgreed}
                    onClick={() => form.submit()}
                    type="primary"
                    className="subbutton"
                  >
                    {t('life.enquiry.submit')}
                  </Button>
                </div>
              </Col>
            </Form>
          </Col>
        </Row>
      </Row>
    </EnquiryPageContainer>
  );
}

export default MakeAnEnquiryPage;
